import type { GetAdminV1StoresStoreIdProductionParams } from '@nucleus-commerce/api-client/admin';

/** Store-scoped production keys; notifications belong to the member, not a store. */
export const productionKeys = {
  all: (storeId: string) => ['stores', storeId, 'production'] as const,
  workflow: (storeId: string, orderId: string) =>
    [...productionKeys.all(storeId), 'workflow', orderId] as const,
  boards: (storeId: string) => [...productionKeys.all(storeId), 'board'] as const,
  board: (storeId: string, params: Omit<GetAdminV1StoresStoreIdProductionParams, 'cursor'>) =>
    [...productionKeys.boards(storeId), params] as const,
  /** Without the flag: the prefix every notification list shares, for invalidation. */
  notifications: (unreadOnly?: boolean) =>
    unreadOnly === undefined
      ? (['me', 'notifications'] as const)
      : (['me', 'notifications', { unreadOnly }] as const),
};
